function toISO(dateStr) {
  if (!dateStr) return null
  const d = new Date(dateStr)
  return isNaN(d) ? null : d.toISOString()
}

export function parseBinanceCSV(rows) {
  return rows.map(r => ({
    market_type: 'crypto',
    exchange: 'Binance',
    symbol: r['Symbol'] || '',
    direction: (r['Side'] || '').toLowerCase() === 'buy' ? 'long' : 'short',
    entry_price: parseFloat(r['Price'] || 0),
    exit_price: null,
    quantity: parseFloat(r['Quantity'] || 0),
    fees: parseFloat(r['Fee'] || 0),
    entry_date: toISO(r['Time(UTC)'] || null),
    exit_date: null,
    status: 'closed',
    pnl: parseFloat(r['Realized Profit'] || 0),
    pnl_percentage: null,
    strategy: '',
    notes: 'Imported from Binance Futures CSV',
    _order_id: r['Order Id'] || null,
  })).filter(t => t.symbol && t.entry_price && t.entry_date)
}

export function mergeBinanceFills(trades) {
  const orderMap = {}
  for (const t of trades) {
    const key = t._order_id || Math.random().toString()
    if (!orderMap[key]) orderMap[key] = []
    orderMap[key].push(t)
  }
  return Object.values(orderMap).map(fills => {
    if (fills.length === 1) {
      const { _order_id, ...trade } = fills[0]
      return trade
    }
    const totalQty = fills.reduce((a, b) => a + b.quantity, 0)
    const avgEntry = fills.reduce((a, b) => a + b.entry_price * b.quantity, 0) / totalQty
    const totalFees = fills.reduce((a, b) => a + b.fees, 0)
    const totalPnl = fills.reduce((a, b) => a + b.pnl, 0)
    const { _order_id, ...base } = fills[0]
    return {
      ...base,
      entry_price: parseFloat(avgEntry.toFixed(6)),
      quantity: parseFloat(totalQty.toFixed(6)),
      fees: parseFloat(totalFees.toFixed(6)),
      pnl: parseFloat(totalPnl.toFixed(4)),
      notes: `Merged ${fills.length} fills — Imported from Binance Futures CSV`,
    }
  })
}

export function parseBybitCSV(rows) {
  return rows.map(r => ({
    market_type: 'crypto',
    exchange: 'Bybit',
    symbol: r['Symbol'] || r['Contract'] || '',
    direction: (r['Side'] || '').toLowerCase() === 'buy' ? 'long' : 'short',
    entry_price: parseFloat(r['Entry Price'] || r['Avg Entry Price'] || r['Price'] || 0),
    exit_price: parseFloat(r['Exit Price'] || r['Avg Exit Price'] || 0) || null,
    quantity: parseFloat(r['Qty'] || r['Size'] || r['Contracts'] || 0),
    fees: parseFloat(r['Trading Fee'] || r['Fee'] || 0),
    entry_date: toISO(r['Open Time'] || r['Created At'] || r['Date']),
    exit_date: toISO(r['Close Time'] || r['Closed At'] || null),
    status: r['Exit Price'] ? 'closed' : 'open',
    pnl: parseFloat(r['Closed P&L'] || r['Realised PNL'] || r['PNL'] || 0),
    pnl_percentage: null,
    strategy: '',
    notes: 'Imported from Bybit CSV',
  })).filter(t => t.symbol && t.entry_price && t.entry_date)
}

export function parseForexCSV(rows) {
  return rows.map(r => ({
    market_type: 'forex',
    exchange: r['Broker'] || r['Account'] || 'FX Broker',
    symbol: r['Symbol'] || r['Instrument'] || r['Pair'] || '',
    direction: (r['Type'] || r['Side'] || r['Direction'] || '').toLowerCase().includes('buy') ? 'long' : 'short',
    entry_price: parseFloat(r['Open Price'] || r['Entry'] || r['Price'] || 0),
    exit_price: parseFloat(r['Close Price'] || r['Exit'] || 0) || null,
    quantity: parseFloat(r['Volume'] || r['Lots'] || r['Size'] || 0),
    fees: parseFloat(r['Commission'] || r['Swap'] || r['Fee'] || 0),
    entry_date: toISO(r['Open Time'] || r['Entry Time'] || r['Date']),
    exit_date: toISO(r['Close Time'] || r['Exit Time'] || null),
    status: 'closed',
    pnl: parseFloat(r['Profit'] || r['PnL'] || r['P&L'] || 0),
    pnl_percentage: null,
    strategy: '',
    notes: 'Imported from FX Broker CSV',
  })).filter(t => t.symbol && t.entry_price && t.entry_date)
}